import style from "./LogoutSuccess.module.css";
import nerLogoLight from "../../assets/icons/NWR_logo_Light_Mood.svg";

const LogoutSuccessComponent = () => {
  return (
    <div className={style["shell"]}>
      <div className={style["signout-card"]}>
        <div className={style["logo"]}>
          <img src={nerLogoLight} alt="NetworkRail logo" />
        </div>

        <h1 className={style["heading"]}>You Signed out of your Account</h1>
        <p className={style["description"]}>
          It’s a good idea to close your browser window.
        </p>
      </div>
    </div>
  );
};
export default LogoutSuccessComponent;
